import React from "react";
import "./EventSchedule.css"; // Assuming you're adding custom styles here

class EventSchedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scheduleData: {},
      locationData: [],
      activeTab: "",
      showInfoPanel: false,
      loading: true,
      tagColors: {
        Vendors: "rgba(31, 119, 180, 0.3)", // Blue with 0.3 opacity
        Theater: "rgba(255, 127, 14, 0.3)", // Orange with 0.3 opacity
        Autographs: "rgba(44, 160, 44, 0.3)", // Green with 0.3 opacity
        "Photo Ops": "rgba(214, 39, 40, 0.3)", // Red with 0.3 opacity
        Workshops: "rgba(148, 103, 189, 0.3)", // Purple with 0.3 opacity
        "Special Event": "rgba(140, 86, 75, 0.3)", // Brown with 0.3 opacity
        VIP: "rgba(23, 190, 207, 0.3)", // Cyan with 0.3 opacity
        Registration: "rgba(127, 127, 127, 0.3)", // Gray with 0.3 opacity
        "Meet & Greet": "rgba(188, 189, 34, 0.3)", // Olive with 0.3 opacity
      },
    };
  }
  componentDidMount() {
    this.fetchScheduleData();
  }

  fetchScheduleData() {
    fetch("https://mobile.creationent.com/data/data_fullEvent.php?eventId=37")
      .then((response) => response.json())
      .then((data) => {
        const _scheduleData = data.eventInfo.schedule;

        // Step 1: Extract unique dates and sort them
        const dates = _scheduleData
          .reduce((accumulator, currentObject) => {
            if (!accumulator.includes(currentObject.date)) {
              accumulator.push(currentObject.date);
            }
            return accumulator;
          }, [])
          .sort((a, b) => new Date(a) - new Date(b)); // Sort dates

        // Step 2: Group schedule items by date and sort by time
        const scheduleData = _scheduleData.reduce(
          (accumulator, currentObject) => {
            const date = currentObject.date;
            if (!accumulator[date]) {
              accumulator[date] = [];
            }
            accumulator[date].push(currentObject);
            return accumulator;
          },
          {}
        );

        // Sort each day's schedule items by time
        Object.keys(scheduleData).forEach((date) => {
          scheduleData[date].sort(
            (a, b) =>
              new Date(`${date} ${a.time}`) - new Date(`${date} ${b.time}`)
          );
        });

        // Step 3: Extract unique locations
        const locationData = _scheduleData.reduce(
          (accumulator, currentObject) => {
            const location = currentObject.location;
            if (!accumulator.includes(location)) {
              accumulator.push(location);
            }
            return accumulator;
          },
          []
        );

        // Auto-select today's date if it exists in the schedule
        const today = new Date().toLocaleDateString("en-US");
        const activeTab = dates.includes(today) ? today : dates[0];

        this.setState({
          scheduleData,
          activeTab: activeTab, // Set today's date or the first date as active tab
          loading: false,
          locationData: locationData,
        });
      });
  }

  toggleInfoPanel = () => {
    this.setState((prevState) => ({
      showInfoPanel: !prevState.showInfoPanel,
    }));
  };
  setActiveTab(date) {
    this.setState({ activeTab: date });
  }

  renderTabs() {
    const { scheduleData, activeTab } = this.state;

    // Sort the dates from earliest to latest
    const sortedDates = Object.keys(scheduleData).sort(
      (a, b) => new Date(a) - new Date(b)
    );

    return (
      <ul className="nav nav-tabs mb-3">
        {sortedDates.map((date) => (
          <li className="nav-item" key={date}>
            <a
              className={`nav-link ${activeTab === date ? "active" : ""}`}
              onClick={() => this.setActiveTab(date)}
              href="#"
            >
              {date}
            </a>
          </li>
        ))}
      </ul>
    );
  }

  renderScheduleTable() {
    const { scheduleData, activeTab, locationData, tagColors } = this.state;
    const activeSchedule = scheduleData[activeTab];

    if (!activeSchedule) return null;

    // Extract unique times for the selected date
    const times = [...new Set(activeSchedule.map((item) => item.time))];

    return (
      <div className="table-responsive schedule-table">
        <table className="table table-bordered table-hover">
          <thead className="thead-light">
            <tr>
              <th className="sticky">Time</th>{" "}
              {/* Sticky header for time column */}
              {locationData.map((location, index) => (
                <th key={index}>{location}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {times.map((time, index) => (
              <tr key={index}>
                <td className="font-weight-bold sticky">{time}</td>{" "}
                {/* Sticky time cells */}
                {locationData.map((location, locIndex) => {
                  const scheduleItem = activeSchedule.find(
                    (item) => item.time === time && item.location === location
                  );
                  return (
                    <td
                      key={locIndex}
                      style={{
                        backgroundColor: scheduleItem
                          ? tagColors[scheduleItem.tags[0]]
                          : "transparent",
                        color: scheduleItem ? "#000000" : "inherit",
                      }}
                    >
                      {scheduleItem ? (
                        <div className="event-name">{scheduleItem.event}</div>
                      ) : (
                        ""
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { loading, showInfoPanel } = this.state;

    return (
      <div className="page-wrapper">
        <main className="page-content">
          <div className="content-container">
            <h2 className="mt-4 mb-3">Event Schedule</h2>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <>
                {this.renderTabs()}
                {this.renderScheduleTable()}
              </>
            )}
          </div>
        </main>
        <footer className="page-footer">
          <p>© 2024 Creation Entertainment. All Rights Reserved.</p>
        </footer>
        {/* Fixed right-side button */}
        <button className="info-btn" onClick={this.toggleInfoPanel}>
          Schedule Information
        </button>

        {/* Slide-out information panel */}
        <div className={`info-panel ${showInfoPanel ? "open" : ""}`}>
          <div className="info-panel-content">
            <h3>Information</h3>
            <div class="info-section">
              <h2>Photo Ops</h2>
              <p>
                Sessions marked with <strong>+</strong> will be called from the
                Theatre by number. Please be seated and wait for your number to
                be called from the stage or on screen if a panel is going on.
                Other sessions are first come, first served.
              </p>
              <ul>
                <li>
                  <strong>PHOTO OP PICKUP (Foyer):</strong> Open during
                  registration hours
                </li>
                <li>
                  <strong>PHOTO OP PDF EXCHANGE (Foyer):</strong> All photo op
                  PDFs with Jensen, Jared, or Misha must be exchanged for an
                  on-site ticket prior to the session.
                </li>
              </ul>

              <h2>Autographs</h2>
              <p>
                <strong>G - GOLD, S - Silver</strong> (Complimentary autographs)
                will be called by row.
              </p>
              <p>
                <strong>Tix:</strong> Pre-purchased autographs (PDF) and tickets
                purchased at the event (on-site) PDFs will be called first,
                followed by on-site tickets.
              </p>
              <p>
                Please be seated in the Theatre and wait for your row/number to
                be called. Autographs will be called from the stage. If there is
                a panel during an autograph session, row/number will be posted
                on the screen.
              </p>
              <p>
                Vendors' room signing times will be displayed at their table(s).
              </p>

              <h2>Schedule Legend</h2>
              <ul>
                <li>
                  <strong>*</strong> Autograph ticket can be purchased directly
                  at the table.
                </li>
                <li>
                  <strong>+ This session</strong> will be called from the
                  Theatre. Please be seated and wait for your group to be
                  called. If a panel is taking place during the photo op
                  session, the group will be displayed on the screen.
                </li>
                <li>
                  <strong>**</strong> If you have Saturday Manns' Cave or
                  Adventure and the J2/Baby photo op, please get your photo op
                  done first in line after VIPs.
                </li>
                <li>
                  <strong>***</strong> If you have Jared's M&G and Jensen/Misha
                  Photos, please get your photo op done on Sunday.
                </li>
                <li>
                  <strong>****</strong> If you have Jensen's meet & greet and
                  photo ops with Jared, please get the photo op first in line
                  after VIPs.
                </li>
                <li>
                  <strong>^</strong> Jensen and Jared are signing ONE item per
                  Gold/Silver patron. Please choose either a non-8x10 photo item
                  (book, poster, t-shirt, etc.) to be signed on Saturday OR an
                  8x10 photo to be signed on Sunday.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EventSchedule;
